import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>     
             Arcadix Cloudflare React Demo -- Preview check
        </p>
        
      </header>
    </div>
  );
}

export default App;
